<template>
	<AppLayout
		:title="trans('enrollments.packs.selections.title')"
		:subtitle="enrollment.user.full_name"
		:return-url="route('events.enrollments.show', enrollment.id)"
		:return-label="trans('enrollments.id', {id: `${enrollment.id}`})"
	>
		<LabeledObject>
			<template #label>{{ trans('enrollments.packs.selections.deadline') }}</template>
			<p>{{ dayjs(selectionStage.ends_at).format(trans('general.dayjs.datetime')) }}</p>
		</LabeledObject>
		<Toggle :pack="pack" :enrollment="enrollment" :activities="activities" :selected-activities-ids="selectedActivitiesIds"/>
	</AppLayout>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {defineProps, type Ref, ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {type Pack} from '@/Types/Events/Packs/Pack'
import {type Activity} from '@/Types/Events/Packs/Activities/Activity'
import Toggle from '@/Components/Enrollments/Activities/Toggle.vue'
import {type Enrollment} from '@/Types/Events/Enrollments/Enrollment'
import {type SelectionStage} from '@/Types/Events/Stages/SelectionStage'
import LabeledObject from '@/Components/LabeledObject.vue'

const props = defineProps<{
	pack:Pack,
	enrollment:Enrollment,
	activities:Array<Activity>,
	selectionStage:SelectionStage,
	selectedActivitiesIds:Array<number>,
}>()

const pack:Ref<Pack> = ref(props.pack)
const enrollment:Ref<Enrollment> = ref(props.enrollment)
const activities:Ref<Array<Activity>> = ref(props.activities)
const selectionStage:Ref<SelectionStage> = ref(props.selectionStage)
const selectedActivitiesIds:Ref<Array<number>> = ref(props.selectedActivitiesIds)
</script>